export class StacksSettings {
  constructor() {
    let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(this, {
      accordionsSpacing: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 20
      },
      accordionsFont: {
        fontSize: 14,
        fontWeight: '600',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      panelSpacing: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 20
      },
      panelFont: {
        fontSize: 13,
        fontWeight: '400',
        color: '#555555',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      minHeight: {
        type: 'auto',
        value: 1
      },
      maxHeight: {
        type: 'px',
        value: 400
      }
    });
    Object.assign(this, c);
  }
}
export const StacksTypes = {
  settings: {
    minHeight: {
      title: 'Min Scroll Height',
      type: 'Size'
    },
    maxHeight: {
      title: 'Max Scroll Height',
      type: 'Size'
    }
  },
  accordions: {
    accordionsSpacing: {
      title: 'Padding',
      type: 'Padding'
    },
    accordionsFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  panel: {
    panelSpacing: {
      title: 'Padding',
      type: 'Padding'
    },
    panelFont: {
      title: 'Font',
      type: 'Font'
    }
  }
};